import { render } from "./wangEditor.vue?vue&type=template&id=ea49f6fe&lang=html"
import script from "./wangEditor.vue?vue&type=script&lang=js"
export * from "./wangEditor.vue?vue&type=script&lang=js"

import "./wangEditor.vue?vue&type=style&index=0&id=ea49f6fe&lang=scss"

import exportComponent from "C:\\Com\\officialServe-vue\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__